import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { HelpFormsService } from "./help-forms.service";
import { MatTableDataSource } from '@angular/material/table';
import * as _ from 'lodash';
import { S3Service } from '../services/s3.service';
import { Router } from '@angular/router';
import { DashboardService } from '../dashboard/dashboard.service';
import { SharedService } from '../services/shared.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-help-forms',
  templateUrl: './help-forms.component.html',
  styleUrls: ['./help-forms.component.scss']
})
export class HelpFormsComponent implements OnInit {

  sortForms = ["All Forms"];
  displayNoRecords: boolean = false;
  displayedColumns = [
    "select",
    "name",
    "sortTopics",
    "subTopics",
    "sortSenders",
    "sortForms",
    "sortTime",
  ];
  fileCabinetForms: any = [];
  bgTextColor = "#000000";
  sortTopics = ["All Topics"];
  sortSubTopics = ["All Sub Topics"];
  sortSenders = ["All Senders"];
  filteredTopic = "";
  filteredSubtopic = "";
  filteredSender = "";
  filteredForm = ""
  tableDataSource = [];

  constructor(
    private _helpFormService: HelpFormsService,
    private _s3Service: S3Service,
    private _router: Router,
    private _dashboardService: DashboardService,
    private _sharedService: SharedService,
    private _snackBar: MatSnackBar,
    private _changeDetectionRef: ChangeDetectorRef
  ) { 
    this._sharedService.searchChange.subscribe((value) => {
      this.fileCabinetForms.filter = value.toLowerCase();
      if (this.fileCabinetForms.filteredData.length === 0) {
        this.displayNoRecords = true;
      } else {
        this.displayNoRecords = false;
      }
    });
  }

  ngOnInit(): void {
    this.onInit();
  }

  ngAfterViewChecked() {
    if (this.check(this.bgTextColor)) {
      this._sharedService.updateHomeColor(this.bgTextColor);
    }
  }

  check(hex) {
    if (/[0-9A-F]{6}$/i.test(hex)) {
      return true;
    }
  }

  onInit(): void {
    let searchInput = document.getElementById("searchInput");
    if (localStorage.getItem("bgTextColor"))
      this.bgTextColor = localStorage.getItem("bgTextColor");
    this.sortTopics = ["All Topics"];
    this.sortSubTopics = ["All Sub Topics"];
    this.sortSenders = ["All Senders"];
    this.sortForms = ["All Forms"];
    this.filteredTopic = "";
    this.filteredSubtopic = "";
    this.filteredSender = "";
    this.filteredForm = "";
		searchInput["value"] = "";
    this.displayNoRecords = false;
    this.fileCabinetForms = [];
    this._helpFormService
      .getHelpForms()
      .subscribe(
        (response) => {
          if (response["success"]) {
            if (response["data"] && response["data"].length > 0) {
              let fileCabinetForms = response["data"];
              if (fileCabinetForms.length > 0) {
                fileCabinetForms.forEach((form) => {
                  form["sortTopics"] = form["sortTopics"]
                    ? _.isString(form["sortTopics"])
                      ? form["sortTopics"]
                      : Object.values(form["sortTopics"])[0]
                    : "";
                  form["subTopics"] = form["subTopics"]
                    ? _.isString(form["subTopics"])
                      ? form["subTopics"]
                      : Object.values(form["subTopics"])[0]
                    : "";

                  if (!_.includes(this.sortTopics, form["sortTopics"])) {
                    if (form["sortTopics"] && form["sortTopics"].length !== 0) {
                      this.sortTopics.push(form["sortTopics"]);
                    }
                  }

                  if (!_.includes(this.sortSubTopics, form["subTopics"])) {
                    if (form["subTopics"] && form["subTopics"].length !== 0) {
                      this.sortSubTopics.push(form["subTopics"]);
                    }
                  }

				          if (!_.includes(this.sortSenders, form["sortSenders"])) {
                    if (form["sortSenders"] && form["sortSenders"].length !== 0) {
                      this.sortSenders.push(form["sortSenders"]);
                    }
                  }

                  if (!_.includes(this.sortForms, form.sortForms)) {
                    if (form["sortForms"] && form["sortForms"].length !== 0) {
											this.sortForms.push(form["sortForms"])
										}
									}

                });
                this.sortFilters()
                this.fileCabinetForms = new MatTableDataSource(fileCabinetForms);
                this._helpFormService.refreshCount([]);
                this.tableDataSource = fileCabinetForms;
              }
            }
          }
          this.sortFilters()
        },
        (error) => {
          console.log(error);
        }
      );
  }

  getFormDetails(formId) {
    this._router.navigateByUrl("/formDetails/HelpForms/" + formId);
  }

  deleteSubmittedForm(formId) {
    // this._sharedService.confirmationDialog(
    //   "This action will move the form to Trash",
    //   () => {
        let requestData = {
          formId: formId,
        };

        this._dashboardService.deleteSubmittedForm(requestData).subscribe(
          (response) => {
            if (response["success"]) {
              this.fileCabinetForms = [];
              this.onInit();
            }
          },
          (error) => {
            console.log(error);
          }
        );
    //   }
    // );
  }

  openSnackBar(message) {
    this._snackBar.open(message, "Ok", {
      duration: 2000,
    });
  }

  onReloadClick(): void {
    this.onInit();
  }

  filterTopics(value): void {
    this.filteredSubtopic = "";
    this.filteredSender = "";
    if (value === "All Topics") {
      this.fileCabinetForms = new MatTableDataSource(this.tableDataSource);
      this._changeDetectionRef.detectChanges();
      this.filteredTopic = "";
      let forms = this.tableDataSource;
      if (forms.length !== 0) {
        this.sortSubTopics = ["All Sub Topics"];
        forms.forEach((form) => {
          if (!_.includes(this.sortSubTopics, form.subTopics)) {
            if (form.subTopics && form.subTopics.length > 0) this.sortSubTopics.push(form.subTopics);
          }
        });
      this.sortSenders = ["All Senders"];
      forms.forEach((form) => {
        if (!_.includes(this.sortSenders, form.sortSenders)) {
          if (form.sortSenders && form.sortSenders.length > 0) this.sortSenders.push(form.sortSenders);
        }
      });
      this.sortFilters()
      }
      return;
    }
    this.filteredTopic = value;
    let forms = this.tableDataSource;
    if (forms.length !== 0) {
      this.sortSubTopics = ["All Sub Topics"];
      forms.forEach((form) => {
        if (
          !_.includes(this.sortSubTopics, form.subTopics) &&
          form.sortTopics === value
        ) {
          this.sortSubTopics.push(form.subTopics);
        }
      });
	  this.sortSenders = ["All Senders"];
		forms.forEach((form) => {
			if (!_.includes(this.sortSenders, form.sortSenders)) {
        if (form.sortSenders && form.sortSenders.length > 0) this.sortSenders.push(form.sortSenders);
			}
		});
    }
    this.filterData("topic");
  }

  filterSubTopics(value): void {
    this.filteredSender = "";
    if(value == "All Sub Topics") {
      this.filteredSubtopic = "";
      let filteredData = this.tableDataSource;
      if(this.filteredTopic && this.filteredTopic.length) {
				filteredData = filteredData.filter(form => form.sortTopics == this.filteredTopic);
			}
			
			this.fileCabinetForms = new MatTableDataSource(filteredData);
			this._changeDetectionRef.detectChanges();

      if(this.filteredSender.length == 0) {
				this.sortSenders = ["All Senders"];
				filteredData.forEach((form) => {
					if (!_.includes(this.sortSenders, form.sortSenders)) {
						if (form.sortSenders && form.sortSenders.length > 0) this.sortSenders.push(form.sortSenders);
					}
				})
			}
      this.sortFilters();
			return;
    }
    this.filteredSubtopic = value;
    let forms = this.tableDataSource;
		if(forms.length != 0) {
			if(this.filteredSender.length == 0) {
				this.sortSenders = ["All Senders"];
				forms.forEach((form) => {
					if (!_.includes(this.sortSenders, form.sortSenders)) {
						if (form.sortSenders && form.sortSenders.length > 0) this.sortSenders.push(form.sortSenders);
					}
				})
			}
		}
    this.filterData("subtopic");
  }

  filterSenders(value): void {
	  if(value == "All Senders") {
      this.filteredSender = "";
      let filteredData = this.tableDataSource;
      if(this.filteredTopic && this.filteredTopic.length) {
        filteredData = filteredData.filter(form => form.sortTopics == this.filteredTopic);
      }
      if(this.filteredTopic && this.filteredSubtopic.length) {
        filteredData = filteredData.filter(form => form.subTopics == this.filteredSubtopic);
      }
      this.fileCabinetForms = new MatTableDataSource(filteredData);
      this._changeDetectionRef.detectChanges();

      if(this.filteredSender.length == 0) {
        this.sortSenders = ["All Senders"];
        filteredData.forEach((form) => {
          if (!_.includes(this.sortSenders, form.sortSenders)) {
            if (form.sortSenders && form.sortSenders.length > 0) this.sortSenders.push(form.sortSenders);
          }
        })
      }
      this.sortFilters()
      return;
	  } 
	  this.filteredSender = value;
    let forms = this.tableDataSource;
    if(forms.length != 0) {
			if(this.filteredSender.length == 0) {
				this.sortSenders = ["All Senders"];
				forms.forEach((form) => {
					if (!_.includes(this.sortSenders, form.sortSenders)) {
						if (form.sortSenders && form.sortSenders.length > 0) this.sortSenders.push(form.sortSenders);
					}
				})
			}
		}
	  this.filterData('sender')
  }

  filterForms(value): void {
    console.log("Filteres", )
	  if(value == "All Forms") {
      this.filteredForm = "";
      let filteredData = this.tableDataSource;
      if(this.filteredTopic && this.filteredTopic.length) {
        filteredData = filteredData.filter(form => form.sortTopics == this.filteredTopic);
      }
      if(this.filteredTopic && this.filteredSubtopic.length) {
        filteredData = filteredData.filter(form => form.subTopics == this.filteredSubtopic);
      }
      if(this.filteredSender && this.filteredSender.length) {
        filteredData = filteredData.filter(form => form.sortSenders == this.filteredSender);
      }
      this.fileCabinetForms = new MatTableDataSource(filteredData);
      this._changeDetectionRef.detectChanges();

      if(this.filteredForm.length == 0) {
        this.sortForms = ["All Forms"];
        filteredData.forEach((form) => {
          if (!_.includes(this.sortForms, form.sortForms)) {
            if (form.sortForms && form.sortForms.length > 0) this.sortForms.push(form.sortForms);
          }
        })
      }
      this.sortFilters()
      return;
	  } 
	  this.filteredForm = value;
    let forms = this.tableDataSource;
    if(forms.length != 0) {
			if(this.filteredSender.length == 0) {
				this.sortForms = ["All Forms"];
				forms.forEach((form) => {
					if (!_.includes(this.sortForms, form.sortForms)) {
						if (form.sortForms && form.sortForms.length > 0) this.sortForms.push(form.sortForms);
					}
				})
			}
		}
	  this.filterData('forms')
  }

  filterData(type) {
    if (type === "topic") {
      let filter = [this.filteredTopic];
      let filteredData = this.tableDataSource.filter((form) => {
        return filter.indexOf(form.sortTopics) > -1;
      });
	  this.sortSenders = ["All Senders"];
	  filteredData.forEach((form) => {
			if (!_.includes(this.sortSenders, form.sortSenders)) {
			  if (form.sortSenders && form.sortSenders.length > 0) this.sortSenders.push(form.sortSenders);
			}
		});
      this.fileCabinetForms = new MatTableDataSource(filteredData);
      this._changeDetectionRef.detectChanges();
    } else if(type == "subtopic") {
      let filteredData = this.tableDataSource;
      if(this.filteredTopic.length) {
				filteredData = filteredData.filter(form => form.sortTopics == this.filteredTopic);
			}
      this.sortSubTopics = ["All Sub Topics"];
			filteredData.forEach((form) => {
				if (!_.includes(this.sortSubTopics, form.subTopics)) {
					if (form.subTopics && form.subTopics.length > 0) this.sortSubTopics.push(form.subTopics);
				}
			})
      filteredData = filteredData.filter(form => form.subTopics == this.filteredSubtopic);
				this.sortSenders = ["All Senders"];
				filteredData.forEach((form) => {
					if (!_.includes(this.sortSenders, form.sortSenders)) {
						if (form.sortSenders && form.sortSenders.length > 0) this.sortSenders.push(form.sortSenders);
					}
				})
			this.fileCabinetForms = new MatTableDataSource(filteredData);
			this._changeDetectionRef.detectChanges();
    } else if(type == "sender") {
		  let filteredData = this.tableDataSource;
			if(this.filteredTopic.length) {
				filteredData = filteredData.filter(form => form.sortTopics == this.filteredTopic);
			}
			if(this.filteredSubtopic.length) {
				filteredData = filteredData.filter(form => form.subTopics == this.filteredSubtopic);
			}
			filteredData = filteredData.filter(form => form.sortSenders == this.filteredSender);
			
			this.fileCabinetForms = new MatTableDataSource(filteredData);
			this._changeDetectionRef.detectChanges();
	  } else if(type == "forms") {
		  let filteredData = this.tableDataSource;
			if(this.filteredTopic.length) {
				filteredData = filteredData.filter(form => form.sortTopics == this.filteredTopic);
			}
			if(this.filteredSubtopic.length) {
				filteredData = filteredData.filter(form => form.subTopics == this.filteredSubtopic);
			}
      if(this.filteredSender.length) {
				filteredData = filteredData.filter(form => form.sortSenders == this.filteredSender);
      }
			filteredData = filteredData.filter(form => form.sortForms == this.filteredForm);
			
			this.fileCabinetForms = new MatTableDataSource(filteredData);
			this._changeDetectionRef.detectChanges();
	  } 
   this.sortFilters()
  }

  sortFilters(fileterElemets?, type?) {
		// topics
		this.sortTopics.sort((a, b) => {
			let tempA = a.toLowerCase();
			let tempB = b.toLowerCase();
				if (tempA < tempB) {
					return -1;
				  }
				  if (tempA > tempB) {
					return 1;
				  }
				  return 0;
			  
		})
		this.sortTopics = this.sortTopics.filter(item => item != "All Topics")
		this.sortTopics = this.sortTopics.filter(item => item != "")
		this.sortTopics.unshift("All Topics");
		
		// Sub topics
		this.sortSubTopics.sort((a, b) => {
			let tempA = a.toLowerCase();
			let tempB = b.toLowerCase();
				if (tempA < tempB) {
					return -1;
				  }
				  if (tempA > tempB) {
					return 1;
				  }
				  return 0;
			  
		})
		this.sortSubTopics = this.sortSubTopics.filter(item => item != "All Sub Topics")
		this.sortSubTopics = this.sortSubTopics.filter(item => item != "")
		this.sortSubTopics.unshift("All Sub Topics");

		// Senders
		this.sortSenders.sort((a, b) => {
			let tempA = a.toLowerCase();
			let tempB = b.toLowerCase();
				if (tempA < tempB) {
					return -1;
				  }
				  if (tempA > tempB) {
					return 1;
				  }
				  return 0;
			  
		})
		this.sortSenders = this.sortSenders.filter(item => item != "All Senders")
		this.sortSenders = this.sortSenders.filter(item => item != "")
		this.sortSenders.unshift("All Senders");

    // Forms
    this.sortForms.sort((a, b) => {
			let tempA = a.toLowerCase();
			let tempB = b.toLowerCase();
				if (tempA < tempB) {
					return -1;
				  }
				  if (tempA > tempB) {
					return 1;
				  }
				  return 0;
			  
		})
		this.sortForms = this.sortForms.filter(item => item != "All Forms")
		this.sortForms = this.sortForms.filter(item => item != "")
		this.sortForms.unshift("All Forms");
	}

  

}
